export type Issue = {
  num: number
  title: string
  subtitle?: string
  tagline: string
  body: string
  cover: string
  pages: Array<string>
}

const CDN = "https://70fy8xbp6b.ufs.sh/f"
const cdn = (key: string) => `${CDN}/${key}`

const ISSUE_1_PAGES = [
  "BzM3qquY5hLZGuLRwLzmgckfZp8Hjs9wCL3dTYvVoqayXJni",
  "BzM3qquY5hLZULY6ikPuR0HZXkI42mVCesp1jNY9PMOoA5BG",
  "BzM3qquY5hLZqpghtcsy8QqUT4WXwnO07dDG6Pz9FtkHxAhb",
  "BzM3qquY5hLZuL9Mjefae4spQcO1wdRkFMiYX2V5UJ7gl6r3",
  "BzM3qquY5hLZVgeWRZiGbBsNpgfRrHakELUZ61QjqlmXMSi9",
  "BzM3qquY5hLZxtuCFV4E68CIKVc7P2JpRWmZa04dSM1qGQgz",
  "BzM3qquY5hLZiQAAtWdvV6aHBk1WmSs9T8IPn2xYy0ezhjfu",
  "BzM3qquY5hLZhD21KIVelw1RnfpMGCxuWjmgAKYqdOXQbB4H",
  "BzM3qquY5hLZxS2Znb4E68CIKVc7P2JpRWmZa04dSM1qGQgz",
]
const ISSUE_2_PAGES = [
  "BzM3qquY5hLZyjl8dqAYwRmOHNY1BzJdgjctWpIy8C4FD2va",
  "BzM3qquY5hLZ4y9PAxECPcvdqme15R07KI2UbHglOfBroA9j",
  "BzM3qquY5hLZKYNPO0oTAlmsSibEhxrXICgkaK8Y5GJuWB3H",
  "BzM3qquY5hLZZjPYyR91c4WIzbkTxRp8VS3j0CwH7OBayNrQ",
  "BzM3qquY5hLZL56W8u7qCzwXFcPYHUx2DeTuSdtyA3vI4q0h",
  "BzM3qquY5hLZEpigvGZSOwICVUTvM7tsWP1kfyae8ZnlzDYR",
  "BzM3qquY5hLZbL1Ae1Wq7kFZujKWmQPvwVCMn8lyeExpc9XA",
  "BzM3qquY5hLZDT3R8Jyt1mqJuWcIYPdGka7oUfCMDnXNrZBs",
  "BzM3qquY5hLZc4LDsEfCIC6mdFl0HiuWPaXK9wMYRAtVvNzJ",
]
const ISSUE_3_PAGES = [
  "BzM3qquY5hLZ47wgdUECPcvdqme15R07KI2UbHglOfBroA9j",
  "BzM3qquY5hLZTovPbstNQvf7i548nB1KuPcMYWwS2kx6F3aN",
  "BzM3qquY5hLZwkJAYQaR41nNHWGrw8Z6E9ktoaBhqgjyxMsC",
  "BzM3qquY5hLZR5ekVlmt3SAJ1dw649HKZUbTGVDhQg82mzNE",
  "BzM3qquY5hLZ5FRZiZp3C1EVf5arFLUZilxH04dvPgjQYz7n",
  "BzM3qquY5hLZ4eOwuRECPcvdqme15R07KI2UbHglOfBroA9j",
  "BzM3qquY5hLZaNjwew61SheGWP7DmICtuwA5r4bUXnVyZ2jq",
  "BzM3qquY5hLZKcPV8BoTAlmsSibEhxrXICgkaK8Y5GJuWB3H",
  "BzM3qquY5hLZsqKadz5TXir3kQM0bHzOp4cYtvyFjDnUmeBu",
]

export const ISSUES: Array<Issue> = [
  {
    num: 1,
    title: "Betrayal Among the Stars",
    tagline: "The foundation of the EKLO-verse commences.",
    body: "A station above the Earth. Two soldiers, one trust, one weapon. The first descent begins not on the ridge — but in the dark between the stars.",
    cover: cdn("BzM3qquY5hLZmjxrU8LDcnsNIHCbjWw0tk8QoXJ4EY1ZFMKy"),
    pages: ISSUE_1_PAGES.map(cdn),
  },
  {
    num: 2,
    title: "Lockdown: Traitor",
    tagline:
      "Survival is a verb spoken between two who once trusted each other.",
    body: "Confined corridors. The lockdown initiates. Ariel learns what survival costs when the person across the table used to call her by her first name.",
    cover: cdn("BzM3qquY5hLZRqLxfDVmt3SAJ1dw649HKZUbTGVDhQg82mzN"),
    pages: ISSUE_2_PAGES.map(cdn),
  },
  {
    num: 3,
    title: "Descent: No Return",
    tagline: "Earth burns at the rim. The ridge is older than the prophecy.",
    body: "The capsule punches through atmosphere. Below, a wasteland. Above, no signal. The trilogy's first frame waits beyond the page.",
    cover: cdn("BzM3qquY5hLZL1zuhRqCzwXFcPYHUx2DeTuSdtyA3vI4q0hs"),
    pages: ISSUE_3_PAGES.map(cdn),
  },
]
